app.service('accountUserView', function (accountUserDataView, message, validate, modal, loading, simpleToastr, pageConfig, passwordInvalid) {

	let $self, thirdPartyCustomerWithoutPassword;

	function open(id) {
		hide();
		if (id == 'user-edit') {
			$self.addClass('show-user-edit-form');
		} else if (id == 'password-edit') {
			$self.addClass('show-password-edit-form');
		} else if (id == 'mail-edit') {
			$self.addClass('show-mail-edit-form');
		} else if (id == 'user-delete') {
			$self.addClass('show-user-delete-form');
		} else if (id == 'date-of-birth-edit') {
			$self.addClass('show-date-of-birth-edit-form');
		}
	}

	function hide() {
		$self.removeClass('show-user-edit-form show-password-edit-form show-mail-edit-form show-user-delete-form show-date-of-birth-edit-form');
	}
	function post(action) {
		loading.start();
		UA.push({
			event: 'button_click',
			button_name: `keycloak-${action}`
		});	
		$.ajax({
			dataType: 'json',
			url: `/send-email-with-action.ltr?action=${action}`,
			method: 'POST',
			success: function(result) {
				if(result.status === 'SUCCESS') {
					simpleToastr.success({
						header: 'Wysłaliśmy wiadomość e-mail z linkiem do ustawienia hasła'
					});
				} else {
					modal.alert('Wystąpił błąd podczas wysyłania wiadomości e-mail. Spróbuj ponownie później.');
				}
			},
			error: function() {
				modal.alert('Wystąpił błąd komunikacji wysyłania wiadomości e-mail. Spróbuj ponownie później.');
			},
			complete: function() {
				loading.stop();
			}
		});
	}
	function alert(content) {
		modal.generate({
			content: content,
			modifier: 'remodal-rwd',
			header: 'Nie możesz usunąć konta',
			buttons: [
				{
					text: 'Rozumiem',
					cssClass: 'btn-rwd-primary',
					click: function(){
						modal.close();
					}
				}
			]
		});
	}
	function checkRemoveAccount() {
		UA.push({
			event: 'button_click',
			button_name: 'delete_account-check'
		});
		loading.start();
		$.ajax({
			dataType: 'json',
			url: '/customer-account-action.ltr?action=REMOVE_ACCOUNT',
			method: 'GET',
			success: function(result) {
				try {
					if(result.removeAccountAllowed) {
						UA.push({
							event: 'button_click',
							button_name: 'delete_account-modal'
						});
						if(result.reauthenticationRequired){
							$('#modal-delete-box').addClass('reauthentication-required');
						} else {
							$('#modal-delete-box').removeClass('reauthentication-required');
						}
						modal.open('delete-box', {
							modifier: 'remodal-rwd',
						});
					} else {
						message.get('customer-password.bhtml - remove_account - ' + result.removeAccountProhibitionReason).then(response => {
							alert(response);
						});
					}
				} catch (e) {
					alert('Wystąpił błąd podczas weryfikacji usuwania konta. Spróbuj ponownie później.');
				}
			}, error: function() {
				alert('Błąd komunikacji podczas weryfikacji usuwania konta. Spróbuj ponownie później.');
			}, complete: function() {
				loading.stop();
			}
		});
	}
	function init() {
		$self = $('#user-edit');
		accountUserDataView.init();
		thirdPartyCustomerWithoutPassword = pageConfig.getData('account').thirdPartyCustomerWithoutPassword;
		$self
			.on('click', '.js-address-change', () => {
				open('user-edit');
			})
			.on('click', '.js-delete-account', () => {
				open('user-delete');
			})
			.on('click', '.js-pass-change', () => {
				open('password-edit');
			})
			.on('click', '.js-email-change', () => {
				open('mail-edit');
			}).on('click', '.js-keycloak-email-change', function() {
				
				function gotoKeycloakLogin(){
					UA.push({
						event: 'button_click',
						button_name: 'update-email-auth'
					});
					loading.redirect(`/customer-account-auth.bhtml?mode=UPDATE_EMAIL&thirdPartyCustomerWithoutPassword=${thirdPartyCustomerWithoutPassword}`);
				}
				function keycloakEmailChangeModal() {
					message.get('customer-password.bhtml - keycloak - update_email - modal').then(result => {
						UA.push({
							event: 'button_click',
							button_name: 'update-email-modal'
						});
						modal.generate({
							modifier: 'remodal-rwd',
							id: 'keycloak-email-change-modal',
							content: result,
							buttons:[
								{
									text: 'Wróć',
									cssClass: 'btn-rwd-third',
									click: function(){
										modal.close();
									}
								}, {
									text: 'Przejdź do logowania',
									cssClass: 'btn-rwd-primary',
									click: function(){
										gotoKeycloakLogin();
									}
								}
							]
						});
					});
				}
				loading.start();
				$.ajax({
					dataType: 'json',
					method: 'GET',
					url: '/customer-account-action.ltr?action=UPDATE_EMAIL',
					success: function(result) {
						if(result.reauthenticationRequired ) {
							keycloakEmailChangeModal();
						} else {
							gotoKeycloakLogin();
						}
					},
					error: function() {
						alert('Błąd komunikacji podczas weryfikacji ponownego uwierzytelnienia. Spróbuj ponownie później.');
					}, complete: function() {
						loading.stop();
					}
				});
				
			}).on('click', '.js-keycloak-email-confirmation', () => {
				UA.push({
					event: 'button_click',
					button_name: 'verify-email-auth'
				});
				loading.redirect(`/customer-account-auth.bhtml?mode=VERIFY_EMAIL_BY_CODE_KME&thirdPartyCustomerWithoutPassword=${thirdPartyCustomerWithoutPassword}`);
			}).on('click', '.js-keycloak-pass-set', () => {
				post('SET_LOCAL_PASSWORD');
			}).on('click', '.js-keycloak-pass-change', () => {
				post('UPDATE_PASSWORD');
			}).on('click', '.js-keycloak-delete-account', () => {
				checkRemoveAccount();
			}).on('click', '.js-date-change', () => {
				open('date-of-birth-edit');
			})
			.on('click', '.js-edit-cancel', () => {
				hide();
			});
			$('body').on('click', '.js-keycloak-delete-reauthenticate', () => {
				if ($('#keycloak-remove-account-form-1').valid()) {
					UA.push({
						event: 'button_click',
						button_name: 'remove-account-auth'
					});
					loading.redirect(`/customer-account-auth.bhtml?mode=REMOVE_ACCOUNT&thirdPartyCustomerWithoutPassword=${thirdPartyCustomerWithoutPassword}`);
				}
			}).on('click', '.js-keycloak-delete-submit', () => {
				if ($('#keycloak-remove-account-form-2').valid()) {
					loading.start();
					UA.push({
						event: 'button_click',
						button_name: 'delete_account-submit'
					});
					$('#keycloak-remove-account-form-2').submit();
				}
			})

		passwordInvalid.init($('#password'), $('#password').parents().find('.password-invalid'), $('#password').closest('.row'), $('#email-hidden'));

		validate.task('userDataPassword');
		validate.task('userDataEmail');
		validate.task('userDataDelete');
		validate.task('userDataDate');
		validate.task('keycloakRemoveAccount');

		if ($('#address-box .error').length) {
			open('user-edit');
		}
		if ($('#email-form .error').length) {
			open('mail-edit');
		}
		if ($('#password-box .error').length) {
			open('password-edit');
		}
		if ($('#date-form .error').length) {
			open('date-of-birth-edit');
		}


	}

	return { init };
});
